

const NextTabButton = function(element) {
    this.element = $(element);
    this.form = this.element.closest('form');
    this.pane = this.element.closest('.tab-pane');

    this.element.on('click', event => {
        event.preventDefault();

        const next = this.pane.next(),
            tab = $('[data-toggle=tab][href="#' + next.attr('id') + '"]');

        if (this.form.length) {
            this.form.ajaxSubmit({
                success: response => {
                    Notifications.messages(response.messages);

                    tab.tab('show');
                }
            });
        } else {
            tab.tab('show');
        }
    })
};

const initNextTabButton = function() {
    const selector = '[data-next-tab]';

    $(document).arrive(selector, {
        existing: true
    }, function() {
        new NextTabButton(this);
    });
};


export { initNextTabButton }


// WEBPACK FOOTER //
// ./js/form/tabs.js